import { ApiError, apiErrorCode } from "./api.js";

const STORAGE_KEY = "zenpay_checkout_offer_token";

export function persistCheckoutOfferToken(token: string | null | undefined): void {
  const trimmed = token?.trim() ?? "";
  try {
    if (trimmed) sessionStorage.setItem(STORAGE_KEY, trimmed);
    else sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* private mode / blocked storage */
  }
}

export function loadPersistedCheckoutOfferToken(): string {
  try {
    return sessionStorage.getItem(STORAGE_KEY)?.trim() ?? "";
  } catch {
    return "";
  }
}

export function resolveCheckoutOfferToken(fromUrl?: string | null): string {
  const query = fromUrl?.trim() ?? "";
  if (query) {
    persistCheckoutOfferToken(query);
    return query;
  }
  return loadPersistedCheckoutOfferToken();
}

export function applyOfferTokenToParams(params: URLSearchParams, offerToken?: string | null): boolean {
  const token = resolveCheckoutOfferToken(offerToken);
  if (!token) return false;
  params.set("offer", token);
  params.set("interval", "monthly");
  return true;
}

export function offerFailureI18nKey(reason?: string | null): string {
  if (reason === "expired") return "checkout.offerExpired";
  if (reason === "fully_redeemed") return "checkout.offerRedeemed";
  return "checkout.offerInvalid";
}

/**
 * Why the server refused an offer token, or null when the request failed for
 * another cause (network, 5xx) and the token is kept for the next try.
 * GET /api/public/offers/:token refuses with 404, POST /api/public/pricing with 400.
 */
export function offerRejectionReason(err: unknown): string | null {
  if (!(err instanceof ApiError)) return null;
  if (err.status !== 400 && err.status !== 404) return null;
  return apiErrorCode(err) ?? "not_found";
}
